import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { RootState } from '../reducers';
import { fetchAssisment, fetchComplaint, fetchCurrentMedication, fetchExam, fetchNoteData, fetchPmh, fetchros } from '../reduxactions/doctoractions/DoctorNotesActions';
import { Button } from 'primereact/button';
import { Editor } from 'primereact/editor';
import { ScrollPanel } from 'primereact/scrollpanel';
import { LoginService } from '../services/LoginService';
import { Card } from 'primereact/card';
import { TabPanel, TabView } from 'primereact/tabview';
import { Panel } from 'primereact/panel';
import './DoctorNotes.css';
import { Dialog } from 'primereact/dialog';
import { InputText } from 'primereact/inputtext';
import { DOCTOR_API } from '../ApiNames';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
// import { Swiper, SwiperSlide } from "swiper/react";

interface Hint {
    label: string;
    value: string;
    title?: string; // Optional if not always present
    description?: string;
}
interface HintData {
    title: string;
    descp: string;
}
interface ApiResponse {
    error: boolean;
    hints: string[];
    arraydata: HintData[] | null;
}



export const DoctorNotes = () => {
    const uid = window.sessionStorage.getItem('uid');

    const [globalFilter, setGlobalFilter] = useState('');
    const [activeIndex, setActiveIndex] = useState(0);
    const stepperRef = useRef(null);

    const location = useLocation();
    const dispatch = useDispatch();

    const [queryParams, setQueryParams] = useState(null);
    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setQueryParams(params.get("id") as any);
    }, [location]);
    const { id } = useParams();
    const getData = useSelector((state: RootState) => state.doctornotes.data);
    const noteDate = getData?.notedetail?.noteDate || '';
    const noteID = getData?.notedetail?.noteId || '';
    const PatientName = `${getData?.patientinfo?.name || ''} ${getData?.patientinfo?.lname || ''}`.trim();
    const DOB = getData?.patientinfo?.DOB || '';
    const Gender = getData?.patientinfo?.Gender || '';
    const PMH = getData?.notedetail?.pastHistory || '';
    const currentMedication = getData?.notedetail?.currentmedication || '';
    const ROS = getData?.notedetail?.reviewofsystem || '';
    const Illness = getData?.notedetail?.complaints || '';
    const Examination = getData?.notedetail?.examination || '';
    const Assesment = getData?.notedetail?.assesment || '';
    const messegess = getData?.diagnosisdetail || '';
    const proceduress = getData?.proceduredetail || '';
    const diacode = (getData?.diagnosisdetail && getData.diagnosisdetail.length > 0) ? getData.diagnosisdetail[0].diacode : '';
    const Description = (getData?.diagnosisdetail && getData.diagnosisdetail.length > 0) ? getData.diagnosisdetail[0].description : '';
    const DXID = (getData?.diagnosisdetail && getData.diagnosisdetail.length > 0) ? getData.diagnosisdetail[0].dxId : '';
    const STATUS = getData?.notedetail?.status || '';

    const diacodeProcedure = (getData?.proceduredetail && getData.proceduredetail.length > 0) ? getData.proceduredetail[0].diacode : '';
    const DescriptionProcedure = (getData?.proceduredetail && getData.proceduredetail.length > 0) ? getData.proceduredetail[0].description : '';
    const PRID = (getData?.proceduredetail && getData.proceduredetail.length > 0) ? getData.proceduredetail[0].dxId : '';
    console.log("status", STATUS)

    useEffect(() => {
        if (getData) {
            const STATUS = getData?.notedetail?.status || '';
            if (STATUS === 'hide') {
                sah();
            }
        }
    }, [getData]);
    //To get data
    const fetchDataAsync = async () => {
        try {
            const data = await dispatch(fetchNoteData(id) as any);
        } catch (error) {
            console.error('Error fetching data:', error);
        }
    };
    useEffect(() => {
        fetchDataAsync();
    }, [dispatch]);
    const [yeardata, setYeardata] = useState(0);

    // Function to calculate age based on DOB
    const calculateAge = (DOB: any) => {
        const birthDate = new Date(DOB);
        const age = new Date().getFullYear() - birthDate.getFullYear();
        const month = new Date().getMonth();
        if (new Date().getMonth() < birthDate.getMonth()) {
            return age - 1;
        }
        return age;
    };

    useEffect(() => {
        if (DOB) {
            setYeardata(calculateAge(DOB)); // Set the calculated age
        }
    }, [DOB]); // Re-run the effect whenever DOB changes

    const [pmhhintsdata, setPmhhintsdata] = useState([]);
    const [filteredHints, setFilteredHints] = useState<any>([]);
    const [selectedHintDescription, setSelectedHintDescription] = useState("");
    const [selectedHintDescriptionval, setSelectedHintDescriptionval] =
        useState("");

    const [pmhValue, setPmhValue] = useState("");
    const [setdatashow, setSetdatashow] = useState<any>({});

    // Fetch PMH data
    const getPmh = async () => {
        const type = "pmh";
        const q = 5;
        const apiname = "/ws_an_newprogrness.php";
        const payload = {
            type,
            caseid: id,
            q,
        };

        try {
            const response = await LoginService.getData(apiname, payload);
            const model = response.data;
            setSetdatashow(model);
            const hints = response.hints.map((hint: string, index: number) => ({
                label: hint,
                value: hint,
                title: response.arraydata[index]?.title || "",
                description: response.arraydata[index]?.descp || "",
            }));
            setPmhhintsdata(hints);
        } catch (err) {
            console.error("Error fetching PMH data:", err);
        }
    };

    // Filter hints based on user input
    const filterHints = (event: any) => {
        // const query = event.query.toLowerCase().trim();
        const query = event;
        if (query.includes(".")) {
            const afterDot = query.split(".")[1].replace(/<\/?[^>]+(>|$)/g, "");
            const afterDotFirstThree = afterDot.substring(0, 3);

            if (afterDotFirstThree.length >= 3) {
                setFilteredHints(
                    pmhhintsdata.filter((hint: any) =>
                        //hint.value.toLowerCase().includes(afterDotFirstThree)
                        hint.value.includes(afterDotFirstThree)
                    )
                );
            } else {
                setFilteredHints(pmhhintsdata);
            }
        }
        setSelectedHintDescriptionval(event);
    };

    // Select hint
    const selectHint = (selectedHint: any) => {
        const newDescription = `<p>${selectedHint.title}</p> <p>${selectedHint.description}</p>`;
        setSelectedHintDescription((prev) => prev + newDescription);
        setSelectedHintDescriptionval((prev) => prev + newDescription);
        setFilteredHints([]);
        //updateValue();
    };

    // const handleTextChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const handleTextChange = (event: any) => {
        // pmhValue(event.target.value);
        filterHints(event);
        textpmheditor(event);
    };
    // Update value logic
    const updateValue = () => {
        if (selectedHintDescriptionval && selectedHintDescription) {
            if (selectedHintDescriptionval === selectedHintDescription) {
                setPmhValue(selectedHintDescriptionval);
            } else {
                setPmhValue(`${selectedHintDescriptionval}`);
            }
        } else {
            setPmhValue(selectedHintDescriptionval || "");
        }
    };

    useEffect(() => {
        getPmh();
    }, []);
    const selectType = (type: string) => {
        console.log("Select type:", type);
        // Add logic for handling type selection
    };
    const textpmheditor = (event: any) => {
        updateeventValue(event);
    };

    const updateeventValue = (value: string) => {
        setSelectedHintDescriptionval(value);
        console.log('selectedHintDescription', value)
        if (value && selectedHintDescription) {
            console.log("Both values are defined and not empty");

            if (value === selectedHintDescription) {
                console.log("Both values are the same");
                setPmhValue(value); // Send selectedHintDescriptionval directly
            } else {
                console.log("Values are different");
                setPmhValue(`${value} `);
            }
        } else {
            console.log("One or both values are empty or undefined");
            setPmhValue(value);
        }

    };

    //Fetch current medication 
    const [cmHintsData, setCmHintsData] = useState<Hint[]>([]);
    const [filteredCmHints, setFilteredCmHints] = useState<Hint[]>([]);
    const [selectedCmHintDescription, setSelectedCmHintDescription] = useState<string>("");
    const [selectedCmHintDescriptionVal, setSelectedCmHintDescriptionVal] = useState<string>("");
    console.log("selectedCmHintDescription", selectedCmHintDescription);
    const [cmValue, setCmValue] = useState<string>("");
    const getCmEd = async () => {
        // Simulates an API call to get current medication data
        const type = "currentmedication";
        const q = 5;
        const apiname = "/ws_an_newprogrness.php";
        const payload = {
            type,
            caseid: id,
            q,
        };

        try {
            const response = await LoginService.getData(apiname, payload);
            if (response.hints && response.hints.length > 0 && response.arraydata) {
                setCmHintsData(
                    response.hints.map((hint: any, index: any) => ({
                        label: hint,
                        value: hint,
                        title: response.arraydata?.[index]?.title || "",
                        description: response.arraydata?.[index]?.descp || "",
                    }))
                );
            } else {
                console.log("No hints or arraydata available");
                setCmHintsData([]);
            }
        } catch (err) {
            console.error("Error fetching PMH data:", err);
        }
    }
    useEffect(() => {
        // Fetch initial data when the component mounts
        getCmEd();
    }, []);

    const textEditor = (event: any) => {
        updateEventCmValue(event);
    };
    const handleTextChange1 = (event: any) => {
        filterCmHints(event);
        textEditor(event);
    };

    const updateEventCmValue = (htmlValue: string) => {
        // Updates cmValue and selectedCmHintDescriptionVal based on the editor's content
        setSelectedCmHintDescriptionVal(htmlValue);

        if (htmlValue && selectedCmHintDescription) {
            if (htmlValue === selectedCmHintDescription) {
                setCmValue(htmlValue); // Send selectedHintDescriptionVal directly
            } else {
                setCmValue(`${htmlValue} `);
            }
        } else {
            setCmValue(htmlValue || "");
        }
    };

    const filterCmHints = (event: any) => {
        //const query = event.htmlValue.toLowerCase().trim();
        const query = event;
        if (query.includes(".")) {
            const afterDot = query.split(".")[1].replace(/<\/?[^>]+(>|$)/g, "");
            const afterDotFirstThree = afterDot.substring(0, 3);
            if (afterDotFirstThree.length >= 3) {
                setFilteredCmHints(
                    cmHintsData.filter((hint) => hint.value.toLowerCase().includes(afterDotFirstThree))
                );
            } else {
                setFilteredCmHints(cmHintsData);
            }
        } else {
            setFilteredCmHints([]);
        }
        setSelectedCmHintDescriptionVal(event.htmlValue);
    };

    const selectCmHint = (curSelectedHint: Hint) => {
        setSelectedCmHintDescription((prev) => `${prev}<p>${curSelectedHint.title}</p> <p>${curSelectedHint.description}</p>`);
        setFilteredCmHints([]);
        setSelectedCmHintDescriptionVal(selectedCmHintDescription);
        updateCmValue();
    };
    const updateCmValue = () => {
        // Updates the cmValue based on the current hint description and value
        if (selectedCmHintDescriptionVal && selectedCmHintDescription) {
            if (selectedCmHintDescriptionVal === selectedCmHintDescription) {
                setCmValue(selectedCmHintDescriptionVal);
            } else {
                setCmValue(`${selectedCmHintDescriptionVal} `);
            }
        } else {
            setCmValue(`${selectedCmHintDescriptionVal || ""} `);
        }
    };

    //Fetch ros Data
    const [rosHintsData, setRosHintsData] = useState<Hint[]>([]);
    const [filteredRosHints, setFilteredRosHints] = useState<Hint[]>([]);
    const [selectedRosHintDescription, setSelectedRosHintDescription] = useState<string>("");
    const [selectedRosHintDescriptionVal, setSelectedRosHintDescriptionVal] = useState<string>("");
    const [rosValue, setRosValue] = useState<string>("");
    const [setDataShow, setSetDataShow] = useState<any>(null);
    const getRos = async () => {
        const apiname = "/ws_an_newprogrness.php";
        const payload = {
            type: 'ros',
            caseid: id,
            q: 5,
        };

        try {
            const response = await LoginService.getData(apiname, payload);
            if (response.hints && response.hints.length > 0 && response.arraydata) {
                setRosHintsData(
                    response.hints.map((hint: any, index: any) => ({
                        label: hint,
                        value: hint,
                        title: response.arraydata?.[index]?.title || '',
                        description: response.arraydata?.[index]?.descp || '',
                    }))
                );
            } else {
                console.log("No hints or arraydata available");
                setRosHintsData([]);
            }
        } catch (err) {
            console.error("Error fetching PMH data:", err);
        }
    }
    // Fetch data on component mount
    useEffect(() => {
        getRos();
    }, []);

    // Function to update the rosValue based on selected description
    const updateRosEventValue = (htmlValue: string) => {
        setSelectedRosHintDescriptionVal(htmlValue);

        if (htmlValue && selectedRosHintDescription) {
            if (htmlValue === selectedRosHintDescription) {
                setRosValue(htmlValue);
            } else {
                setRosValue(`${htmlValue} `);
            }
        } else {
            setRosValue(htmlValue || "");
        }
    };

    // Function to handle changes in the editor (called from the editor component)
    const textRosEditor = (event: any) => {
        updateRosEventValue(event);
    };

    // Function to filter the ROS hints based on input
    const filterRosHints = (event: any) => {
        //const query = event.htmlValue.toLowerCase().trim();
        const query = event;

        if (query.includes(".")) {
            const afterDot = query.split(".")[1].replace(/<\/?[^>]+(>|$)/g, "");
            const afterDotFirstThree = afterDot.substring(0, 3);

            if (afterDotFirstThree.length >= 3) {
                setFilteredRosHints(
                    rosHintsData.filter((hint) =>
                        hint.value.toLowerCase().includes(afterDotFirstThree)
                    )
                );
            } else {
                setFilteredRosHints(rosHintsData);
            }
        } else {
            setFilteredRosHints([]);
        }
        setSelectedRosHintDescriptionVal(event.htmlValue);
    };

    // Function to select a ROS hint and update the selected description
    const selectRosHint = (selectedHint: Hint) => {
        setSelectedRosHintDescription(prev => `${prev}<p>${selectedHint.title}</p><p>${selectedHint.description}</p>`);
        setFilteredRosHints([]);
        setSelectedRosHintDescriptionVal(selectedRosHintDescription);
        updateRosValue();
    };
    const handleTextChange2 = (event: any) => {
        filterRosHints(event);
        textRosEditor(event);
    };



    // Function to update the ROS value after selection or change
    const updateRosValue = () => {
        if (selectedRosHintDescriptionVal && selectedRosHintDescription) {
            if (selectedRosHintDescriptionVal === selectedRosHintDescription) {
                setRosValue(selectedRosHintDescriptionVal);
            } else {
                setRosValue(`${selectedRosHintDescriptionVal} `);
            }
        } else {
            setRosValue(`${selectedRosHintDescriptionVal || ""} `);
        }
    };

    //Fetch 
    const [filteredHpiHints, setFilteredHpiHints] = useState<any[]>([]);
    const [selectedHpiHintDescription, setSelectedHpiHintDescription] = useState<string>('');
    const [selectedHpiHintDescriptionVal, setSelectedHpiHintDescriptionVal] = useState<string>('');
    const [hpiValue, setHpiValue] = useState<string>('');
    const [hpiHintsData, setHpiHintsData] = useState<any[]>([]);

    // Function to fetch HPI hints data (like the gethpi method in Angular)
    const getHpi = async () => {
        const type = 'complaint';
        const q = 5;
        const apiName = '/ws_an_newprogrness.php';
        const payload = {
            type,
            caseid: id,
            q,
        };

        try {
            const response = await LoginService.getData(apiName, payload);
            const model = response.data;
            setSetDataShow(model);
            const hints = response.hints.map((hint: string, index: number) => ({
                label: hint,
                value: hint,
                title: response.arraydata[index]?.title || '',
                description: response.arraydata[index]?.descp || '',
            }));

            setHpiHintsData(hints);
        } catch (err) {
            console.error("Error fetching HPI data:", err);
        }
    };



    // Function to update the hpiValue
    const updateHpiValue = () => {
        if (selectedHpiHintDescriptionVal && selectedHpiHintDescription) {
            if (selectedHpiHintDescriptionVal === selectedHpiHintDescription) {
                setHpiValue(selectedHpiHintDescriptionVal); // Send selectedHintDescriptionVal directly
            } else {
                setHpiValue(`${selectedHpiHintDescriptionVal} `);
            }
        } else {
            setHpiValue(`${selectedHpiHintDescriptionVal} `);
        }
    };

    const updateHpiEventValue = (htmlValue: any) => {
        setSelectedHpiHintDescriptionVal(htmlValue);

        if (htmlValue && selectedHpiHintDescription) {
            if (htmlValue === selectedHpiHintDescription) {
                setHpiValue(htmlValue);
            } else {
                setHpiValue(`${htmlValue} `);
            }
        } else {
            setHpiValue(htmlValue);
        }

        console.log("hpiValue:", hpiValue);
    };

    const handleHpiTextChange = (event: any) => {
        updateHpiEventValue(event);
    };

    // Function to handle the text change in the editor
    const filterHpiHints = (event: any) => {
        //const query = event.htmlValue.toLowerCase().trim();
        const query = event;
        if (query.includes('.')) {
            const afterDot = query.split('.')[1].replace(/<\/?[^>]+(>|$)/g, '');
            const afterDotFirstThree = afterDot.substring(0, 3);

            if (afterDotFirstThree.length >= 3) {
                setFilteredHpiHints(
                    hpiHintsData.filter((hint) =>
                        hint.value.toLowerCase().includes(afterDotFirstThree)
                    )
                );
            } else {
                setFilteredHpiHints(hpiHintsData);
            }
        } else {
            setFilteredHpiHints([]);
        }

        setSelectedHpiHintDescriptionVal(event.htmlValue);
    };

    // Function to select a specific HPI hint
    const selectHpiHint = (selectedHint: any) => {
        setSelectedHpiHintDescription((prev) => `${prev}<p>${selectedHint.title}</p> <p>${selectedHint.description}</p>`);
        setFilteredHpiHints([]);
        setSelectedHpiHintDescriptionVal(selectedHpiHintDescription);
        updateHpiValue();
    };
    const handleTextChange3 = (event: any) => {
        filterHpiHints(event);
        handleHpiTextChange(event);
    };

    useEffect(() => {
        getHpi(); // Fetch HPI hints data on mount
    }, []);



    //Fetch Examination
    const [examHintsData, setExamHintsData] = useState<any[]>([]);
    const [filteredExamHints, setFilteredExamHints] = useState<any[]>([]);
    const [selectedExamHintDescription, setSelectedExamHintDescription] = useState('');
    const [selectedExamHintDescriptionVal, setSelectedExamHintDescriptionVal] = useState('');
    const [examValue, setExamValue] = useState('');

    const getExam = async () => {
        const type = 'exam';
        const q = 5;
        const apiName = '/ws_an_newprogrness.php';
        const payload = {
            type,
            caseid: id,
            q
        };

        try {
            const response = await LoginService.getData(apiName, payload);
            const model = response.data;
            setSetDataShow(model);
            const hints = response.hints.map((hint: string, index: number) => ({
                label: hint,
                value: hint,
                title: response.arraydata[index]?.title || '',
                description: response.arraydata[index]?.descp || '',
            }));

            setExamHintsData(hints);
        } catch (err) {
            console.error("Error fetching HPI data:", err);
        }
    };

    const updateExamEventValue = (htmlValue: any) => {
        setSelectedExamHintDescriptionVal(htmlValue);
        if (htmlValue && selectedExamHintDescription) {
            if (htmlValue === selectedExamHintDescription) {
                setExamValue(htmlValue);
            } else {
                setExamValue(`${htmlValue} `);
            }
        } else {
            setExamValue(htmlValue);
        }

    };

    const textExamEditor = (event: any) => {
        updateExamEventValue(event);
    };

    const filterExamHints = (event: any) => {
        const query = event;

        if (query.includes('.')) {
            const afterDot = query.split('.')[1].replace(/<\/?[^>]+(>|$)/g, '');
            const afterDotFirstThree = afterDot.substring(0, 3);

            if (afterDotFirstThree.length >= 3) {
                setFilteredExamHints(
                    examHintsData.filter((hint: any) =>
                        hint.value.toLowerCase().includes(afterDotFirstThree)
                    )
                );
            } else {
                setFilteredExamHints(examHintsData);
            }
        } else {
            setFilteredExamHints([]);
        }
        setSelectedExamHintDescriptionVal(event.htmlValue);
    };

    const selectExamHint = (selectedHint: any) => {
        setSelectedExamHintDescription(
            `${selectedExamHintDescription}<p>${selectedHint.title}</p> <p>${selectedHint.description}</p>`
        );
        setFilteredExamHints([]);
        setSelectedExamHintDescriptionVal(selectedExamHintDescription);
        updateExamValue();
    };

    const handleTextChange4 = (event: any) => {
        filterExamHints(event);
        textExamEditor(event);
    };

    const clearExamSelection = () => {
        setSelectedExamHintDescription('');
        setFilteredExamHints([]);
    };

    const updateExamValue = () => {
        if (selectedExamHintDescriptionVal && selectedExamHintDescription) {
            if (selectedExamHintDescriptionVal === selectedExamHintDescription) {
                setExamValue(selectedExamHintDescriptionVal);
            } else {
                setExamValue(`${selectedExamHintDescriptionVal} `);
            }
        } else {
            setExamValue(`${selectedExamHintDescriptionVal} `);
        }
    };

    useEffect(() => {
        getExam();
    }, []);

    //Fetch Assesment
    const [selectedAssessmentHintDescription, setSelectedAssessmentHintDescription] = useState('');
    const [assesValue, setAssesValue] = useState('');
    const [assPlanHintsData, setAssPlanHintsData] = useState<Hint[]>([]);
    const [filteredAssessmentHints, setFilteredAssessmentHints] = useState<Hint[]>([]);
    const [selectedAssessmentHintDescriptionVal, setSelectedAssessmentHintDescriptionVal] = useState<string>('');
    const getAssessment = async () => {
        const type = 'assesment';
        const q = 5;
        const apiname = "/ws_an_newprogrness.php";
        const payload = { type, caseid: id, q };

        try {
            const response = await LoginService.getData(apiname, payload);
            const model = response.data;
            setSetDataShow(model);
            setAssPlanHintsData(
                response.hints.map((hint: any, index: any) => ({
                    label: hint,
                    value: hint,
                    title: response.arraydata[index]?.title || '',
                    description: response.arraydata[index]?.descp || ''
                }))
            );
        } catch (err) {
            console.error('Error fetching assessment data:', err);
        }
    };

    useEffect(() => {
        getAssessment();
    }, [dispatch]);

    const updateAssessmentValue = (htmlValue: any) => {
        setSelectedAssessmentHintDescriptionVal(htmlValue);
        if (htmlValue && selectedAssessmentHintDescription) {
            if (htmlValue === selectedAssessmentHintDescription) {
                setAssesValue(htmlValue);
            } else {
                setAssesValue(`${htmlValue} `);
            }
        } else {
            setAssesValue(htmlValue);
        }

    };

    const textAssessmentEditor = (event: any) => {
        updateAssessmentValue(event);
    };

    const filterAssessmentHints = (event: any) => {
        const query = event;

        console.log('Event query:', query);
        console.log('assPlanHintsData length:', assPlanHintsData.length);
        console.log('assPlanHintsData:', assPlanHintsData);

        if (query.includes('.')) {
            const afterDot = query.split('.')[1].replace(/<\/?[^>]+(>|$)/g, ''); // Strip HTML tags
            const afterDotFirstThree = afterDot.substring(0, 3);
            console.log('After dot:', afterDotFirstThree);

            if (afterDotFirstThree.length >= 3) {
                setFilteredAssessmentHints(
                    assPlanHintsData.filter((hint) => hint.value.toLowerCase().includes(afterDotFirstThree))
                );
            } else {
                setFilteredAssessmentHints(assPlanHintsData); // Show all if less than 3 chars after dot
            }
        } else {
            setFilteredAssessmentHints([]); // Show all hints if no dot
        }

        setSelectedAssessmentHintDescriptionVal(event.htmlValue);
        console.log('Filtered assessment hints:', filteredAssessmentHints);
    };





    const selectAssessmentHint = (assessmentSelectedHint: any) => {
        setSelectedAssessmentHintDescription((prev) => `${prev} <p>${assessmentSelectedHint.title}</p> <p>${assessmentSelectedHint.description}</p>`);
        setFilteredAssessmentHints([]); // Clear filtered hints after selection
        setSelectedAssessmentHintDescriptionVal(selectedAssessmentHintDescription);
        updateAssValue();
    };
    const handleTextChange5 = (event: any) => {
        filterAssessmentHints(event);
        textAssessmentEditor(event);
    };

    const clearAssessmentSelection = () => {
        console.log('selection:', 'entered clear');
        setSelectedAssessmentHintDescription(''); // Clear the selected hint description
        setFilteredAssessmentHints([]); // Clear filtered hints
    };

    const updateAssValue = () => {
        if (selectedAssessmentHintDescriptionVal && selectedAssessmentHintDescription) {
            console.log('Both values are defined and not empty');
            if (selectedAssessmentHintDescriptionVal === selectedAssessmentHintDescription) {
                console.log('Both values are the same');
                setAssesValue(selectedAssessmentHintDescriptionVal); // Set directly
            } else {
                console.log('Values are different');
                setAssesValue(`${selectedAssessmentHintDescriptionVal} `); // Merge them
            }
        } else {
            console.log('One or both values are empty or undefined');
            setAssesValue(`${selectedAssessmentHintDescriptionVal} `); // Set the val directly
        }

        console.log('assesValue:', assesValue);
    };

    //dilog
    const [name, setName] = useState('');
    const [title, setTitle] = useState('');
    const [editable, setEditable] = useState('');
    const [dialogPosition, setDialogPosition] = useState<'top' | 'center' | 'bottom'>('center'); // Set a default value
    const [diagnosisDilog, setDaignosisDilog] = useState(false);
    const [procedureDilog, setProcedureDilog] = useState(false);
    const [diagnosisName, setDaignosisName] = useState('');
    const [procedureName, setProcedureName] = useState('');

    const [diagnosisData, setDiagnosisData] = useState<[]>([]);
    const [showTable, setShowTable] = useState(false);
    const [selectedId, setSelectedId] = useState(null);
    const [removeId, setRemoveId] = useState(null);

    const getDiagnosis = async () => {
        try {
            const payload = { name: diagnosisName, type: 'icd10', q: 7 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setDiagnosisData(data);
            setShowTable(true);
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const [procedureData, setProcedureData] = useState<[]>([]);
    const [showTable1, setShowTable1] = useState(false);
    const getProcedure = async () => {
        try {
            const payload = { type: 'procedure', q: 7 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setProcedureData(data);
            setShowTable1(true);
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };

    const handleIconClick = (dxId: any) => {
        setSelectedId(dxId);
        console.log('Selected dxId:', dxId);
        addDiagnosis(dxId);
    };
    const handleIconClick1 = (dxId: any) => {
        setSelectedId(dxId);
        console.log('Selected dxId:', dxId);
        addProcedure(dxId);
    };


    const addDiagnosis = async (dxId: any) => {
        try {
            const payload = { id: dxId, caseid: id, q: 8 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setShowTable(false);
            setDaignosisDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const addProcedure = async (dxId: any) => {
        try {
            const payload = { id: dxId, caseid: id, q: 8 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setShowTable1(false);
            setProcedureDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const removeDiagnosis = async (DXID: any) => {
        try {
            const payload = { id: DXID, caseid: id, q: 9 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    const removeProcedure = async (PRID: any) => {
        try {
            const payload = { id: PRID, caseid: id, q: 9 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    //for .Enter Entry
    const handleKeyDown = (e: any) => {
        if (e.key === 'Enter') {
            getDiagnosis();
        }
    };
    const handleKeyDown1 = (e: any) => {
        if (e.key === 'Enter') {
            getProcedure();
        }
    };

    //add past medical history
    const [openDilog, setOpenDilog] = useState(false);
    const [pastname, setPastName] = useState('');
    const [pasttitle, setPastTitile] = useState('');
    const [pastmedicalEditable, setPastmedicalEditable] = useState('');
    const addPastMedicalHistory = async () => {
        try {
            const payload = { name: pastname, title: pasttitle, newnote: pastmedicalEditable, caseid: id, type: 'pmh', q: 6 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setOpenDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    //for .Enter Entry
    const handlePast = (e: any) => {
        if (e.key === 'Enter') {
            addPastMedicalHistory();
        }
    };


    //current medication
    const [medicationDilog, setMedicationDilog] = useState(false);
    const [currentName, setCurrentName] = useState('');
    const [currentTitle, setCurrentTitle] = useState('');
    const [currentEditable, setCurrentEditable] = useState('');

    const addCurrentMedication = async () => {
        try {
            const payload = { name: currentName, title: currentTitle, newnote: currentEditable, caseid: id, type: 'currentmedication', q: 6 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setMedicationDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };

    //ros
    const [rosDilog, setrosDilog] = useState(false);
    const [reviewName, setReviewName] = useState('');
    const [reviewTitle, setReviewTitle] = useState('');
    const [rosEditable, setRosEditable] = useState('');
    const addRosData = async () => {
        try {
            const payload = { name: reviewName, title: reviewTitle, newnote: rosEditable, caseid: id, type: 'ros', q: 6 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setrosDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };

    //present illness
    const [illnessDilog, setIllnessDilog] = useState(false);
    const [illnessName, setIllness] = useState('');
    const [illnessTitle, setIllnessTitle] = useState('');
    const [illnesseditable, setillnesseditable] = useState('');

    const addIllnessData = async () => {
        try {
            const payload = { name: illnessName, title: illnessTitle, newnote: illnesseditable, caseid: id, type: 'complaint', q: 6 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setIllnessDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };

    //Examination
    const [ExamDilog, setExamDilog] = useState(false);
    const [examinationName, setExamName] = useState('');
    const [examinationTitle, setExamTitle] = useState('');
    const [ExamineEditable, setExamEditable] = useState('');

    const addExamineData = async () => {
        try {
            const payload = { name: examinationName, title: examinationTitle, newnote: ExamineEditable, caseid: id, type: 'exam', q: 6 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setExamDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    //Assesment
    const [AssesmentDilog, setAssesmentDilog] = useState(false);
    const [assesmentName, setAssesmentName] = useState('');
    const [assesmentTitle, setassesmentTitle] = useState('');
    const [AssesmbleEditable, setAssembleEditable] = useState('');

    const addAssesmentData = async () => {
        try {
            const payload = { name: assesmentName, title: assesmentTitle, newnote: AssesmbleEditable, caseid: id, type: 'assesment', q: 6 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            setAssesmentDilog(false);
            window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };


    //ssave notes
    const SaveNotes = async () => {
        try {
            const payload = { 'pmh': pmhValue, 'currentmed': cmValue, 'ros': rosValue, 'hpi': hpiValue, 'exam': examValue, 'ass': assesValue, caseid: id, q: 4 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            //window.location.reload();
        } catch (error) {
            console.error('Error fetching address data:', error);
        }
    };
    //sign notes
    const [isDisabled, setIsDisabled] = useState(false);

    const sid = "";
    const signNote = async () => {
        try {
            const payload = { id: sid, caseid: id, q: 10 };
            const apiname = DOCTOR_API.notes_API;
            const data = await LoginService.getData(apiname, payload);
            sah();
        } catch (error) {
            console.error("Error while calling API:", error);
        }
    };


    const sah = () => {
        setIsDisabled(true);
    };
    //for help
    const [openHelp, setHelp] = useState(false);
    const url1 = window.sessionStorage.getItem("apiRoot");
    const IUrl = `${url1}/help/doctornotes.php`;
    const helpImg = `${url1}/help/help3.png`;
    const openWindow = (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>, targetUrl: string): void => {
        event.preventDefault();
        const newWindowReference = window.open(
            targetUrl,
            'newwindow',
            'width=1000,height=1000,noopener,noreferrer'
        );

        if (newWindowReference) {
            newWindowReference.opener = null;
        }
    };
    return (
        <div className="admin-layout-container" >
            <div className={isDisabled ? "disabledDiv" : ''}>
                <div className="main-content">
                    <div className="content-wrapper">
                        <br />
                        <div className="col-16" style={{ textAlign: "right" }}>
                            <a
                                title="help"
                                onClick={(e) => openWindow(e, IUrl)}
                                style={{

                                    color: "blue",
                                    fontSize: 15, cursor: "pointer"
                                }}
                            >Help for this Page &nbsp;
                                <i style={{ marginTop: 40, backgroundColor: "orange", color: "white" }} className="pi pi-question-circle"></i>

                            </a>
                        </div>
                        <div>
                            <div className="grid" style={{ marginLeft: '10px' }}>

                                {/* Left Column */}
                                <div className="col-md-8">
                                    <p style={{ fontSize: '20px', color: 'rgb(91, 91, 219)' }}>
                                        <b style={{ fontSize: '20px', color: 'rgb(91, 91, 219)' }}>Case Id</b>: {noteID}
                                        &nbsp;&nbsp;
                                        <span className="vl" style={{ borderLeft: '1px solid #ddd', margin: '0 10px' }}></span>

                                        <b style={{ fontSize: '20px', color: 'rgb(91, 91, 219)' }}>Patient</b>: {PatientName}
                                        &nbsp;&nbsp;
                                        <span className="vl" style={{ borderLeft: '1px solid #ddd', margin: '0 10px' }}></span>

                                        <b style={{ fontSize: '20px', color: 'rgb(91, 91, 219)' }}>DOB</b>: {DOB}
                                        &nbsp;&nbsp;
                                        <span className="vl" style={{ borderLeft: '1px solid #ddd', margin: '0 10px' }}></span>

                                        <b style={{ fontSize: '20px', color: 'rgb(91, 91, 219)' }}>DOS</b>: {noteDate}
                                    </p>
                                </div>

                                {/* Right Column */}
                                <div className="col-md-4" style={{ display: 'flex', alignItems: 'center' }}>
                                    <Button label="Save Notes" style={{ marginLeft: '30px', backgroundColor: 'rgb(91, 91, 219)' }} onClick={SaveNotes} />
                                    <Button label="Sign Notes" className="pl-3" style={{ marginLeft: '20px', backgroundColor: 'rgb(91, 91, 219)' }} onClick={signNote} />
                                </div>

                                <div className="row" style={{ marginLeft: '10px' }}>
                                    <span style={{ fontSize: '15px' }}>
                                        {yeardata} years old {Gender} patient, {PatientName} was seen on {noteDate} as a followup patient.
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row" style={{ marginLeft: "-20px" }}>
                        <div className="col-14">
                            <div className="grid">
                                <div className='col-4'>
                                    <Panel style={{ width: '380px' }}>
                                        <div className="summarydata-card-4">
                                            <h3 style={{ fontSize: '18px', marginTop: '10px', color: 'rgb(91, 91, 219)' }}>
                                                Past Medical History
                                            </h3>
                                            <i
                                                className="pi pi-cog"
                                                onClick={() => setOpenDilog(true)}
                                                style={{
                                                    fontSize: "20px",
                                                    color: "rgb(91, 91, 219)",
                                                    float: "right",
                                                    cursor: "pointer",
                                                    marginTop: '-20px'

                                                }}
                                            ></i>
                                            {/* Hints Container */}
                                            <div className="hints-container" style={{ marginTop: '10px' }}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        overflowY: 'auto',
                                                        scrollSnapType: 'y mandatory',
                                                        gap: '5px',
                                                        padding: '5px',
                                                        maxHeight: '200px',
                                                    }}
                                                >
                                                    {filteredHints.slice(0, 1).map((hint: any, index: any) => (
                                                        <div
                                                            key={index}
                                                            style={{
                                                                flex: '0 0 auto',
                                                                scrollSnapAlign: 'start',
                                                                padding: '10px',
                                                                backgroundColor: '#f0f0f0',
                                                                borderRadius: '4px',
                                                            }}
                                                        >
                                                            <a
                                                                href="javascript:void(0);"
                                                                onClick={() => selectHint(hint)}
                                                                style={{
                                                                    textDecoration: 'none',
                                                                    color: '#333',
                                                                }}
                                                            >
                                                                {hint.value}
                                                            </a>
                                                        </div>
                                                    ))}

                                                    {/* Render the remaining hints with scrollable style */}
                                                    {filteredHints.length > 1 && (
                                                        <div className="scrollable-hints">
                                                            {filteredHints.slice(1).map((hint: any, index: any) => (
                                                                <div
                                                                    key={index}
                                                                    style={{
                                                                        flex: '0 0 auto',
                                                                        scrollSnapAlign: 'start',
                                                                        padding: '10px',
                                                                        backgroundColor: '#f0f0f0',
                                                                        borderRadius: '4px',
                                                                    }}
                                                                >
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        onClick={() => selectHint(hint)}
                                                                        style={{
                                                                            textDecoration: 'none',
                                                                            color: '#333',
                                                                        }}
                                                                    >
                                                                        {hint.value}
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Editor */}
                                            <Editor
                                                style={{ width: '100%', height: 'auto' }}
                                                value={selectedHintDescription || PMH}
                                                onTextChange={(e) => handleTextChange(e.htmlValue)} />
                                        </div>
                                    </Panel>

                                    <Panel style={{ width: '380px' }}>
                                        <div className="summarydata-card-4">
                                            <h3 style={{ fontSize: '18px', color: 'rgb(91, 91, 219)' }}>
                                                Current Medication
                                            </h3>
                                            <i
                                                className="pi pi-cog"
                                                onClick={() => setMedicationDilog(true)}
                                                style={{
                                                    fontSize: "20px",
                                                    color: "rgb(91, 91, 219)",
                                                    float: "right",
                                                    cursor: "pointer",
                                                    marginTop: '-20px'
                                                }}
                                            ></i>
                                            {/* Hints Container */}
                                            {/* <div className="hints-container" style={{ marginTop: '10px' }}>
                                            <div className="fixed-height-container">
                                                {filteredCmHints.slice(0, 1).map((hint) => (
                                                    <a href="javascript:void(0);" onClick={() => selectCmHint(hint)} key={hint.value}>
                                                        {hint.value}
                                                    </a>
                                                ))}
                                            </div>
                                            {filteredCmHints.length > 1 && (
                                                <div className="scrollable-hints">
                                                    {filteredCmHints.slice(1).map((hint) => (
                                                        <a href="javascript:void(0);" onClick={() => selectCmHint(hint)} key={hint.value}>
                                                            {hint.value}
                                                        </a>
                                                    ))}
                                                </div>
                                            )}
                                        </div> */}

                                            <div className="hints-container" style={{ marginTop: '10px' }}>
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        flexDirection: "column",
                                                        overflowY: "auto",
                                                        scrollSnapType: "y mandatory",
                                                        gap: "5px",
                                                        padding: "5px",
                                                        maxHeight: "200px",
                                                    }}
                                                >
                                                    {/* Render the first hint (fixed height) */}
                                                    {filteredCmHints.slice(0, 1).map((hint) => (
                                                        <div
                                                            key={hint.value}
                                                            style={{
                                                                flex: "0 0 auto",
                                                                scrollSnapAlign: "start",
                                                                padding: "10px",
                                                                backgroundColor: "#f0f0f0",
                                                                borderRadius: "4px",
                                                            }}
                                                        >
                                                            <a
                                                                href="javascript:void(0);"
                                                                onClick={() => selectCmHint(hint)}
                                                                style={{
                                                                    textDecoration: "none",
                                                                    color: "#333",
                                                                }}
                                                            >
                                                                {hint.value}
                                                            </a>
                                                        </div>
                                                    ))}

                                                    {/* Render the rest of the hints (scrollable) */}
                                                    {filteredCmHints.length > 1 && (
                                                        <div className="scrollable-hints">
                                                            {filteredCmHints.slice(1).map((hint) => (
                                                                <div
                                                                    key={hint.value}
                                                                    style={{
                                                                        flex: "0 0 auto",
                                                                        scrollSnapAlign: "start",
                                                                        padding: "10px",
                                                                        backgroundColor: "#f0f0f0",
                                                                        borderRadius: "4px",
                                                                    }}
                                                                >
                                                                    <a
                                                                        href="javascript:void(0);"
                                                                        onClick={() => selectCmHint(hint)}
                                                                        style={{
                                                                            textDecoration: "none",
                                                                            color: "#333",
                                                                        }}
                                                                    >
                                                                        {hint.value}
                                                                    </a>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>

                                            {/* Editor */}
                                            <Editor
                                                style={{ width: '100%', height: 'auto' }}
                                                value={selectedCmHintDescription || currentMedication}
                                                onTextChange={(e) => handleTextChange1(e.htmlValue)} />
                                        </div>
                                    </Panel>

                                    <Panel style={{ width: '380px' }}>
                                        <div className="summarydata-card-4">
                                            <h3 style={{ fontSize: '18px', marginTop: '10px', color: 'rgb(91, 91, 219)' }}>
                                                Review Of System
                                            </h3>
                                            <i
                                                className="pi pi-cog"
                                                style={{ fontSize: '20px', color: 'rgb(91, 91, 219)', float: 'right', marginTop: '-20px' }}
                                                onClick={() => setrosDilog(true)}
                                            ></i>
                                            {/* Hints Container */}
                                            {/* <div className="hints-container" style={{ marginTop: '10px' }}>
                                            <div className="fixed-height-container">
                                                {filteredRosHints.slice(0, 1).map((hint, index) => (
                                                    <a href="javascript:void(0);" onClick={() => selectRosHint(hint)} key={index}>
                                                        {hint.value}
                                                    </a>
                                                ))}
                                            </div>
                                            {filteredRosHints.length > 1 && (
                                                <div className="scrollable-hints">
                                                    {filteredRosHints.slice(1).map((hint, index) => (
                                                        <a href="javascript:void(0);" onClick={() => selectRosHint(hint)} key={index}>
                                                            {hint.value}
                                                        </a>
                                                    ))}
                                                </div>
                                            )}
                                        </div> */}
                                            <div className="hints-container" style={{ marginTop: '10px' }}>
                                                <div style={{ display: "flex", flexDirection: "column", overflowY: "auto", scrollSnapType: "y mandatory", gap: "5px", padding: "5px", maxHeight: "200px" }}>
                                                    {filteredRosHints.map((hint, index) => (
                                                        <div key={index} style={{ flex: "0 0 auto", scrollSnapAlign: "start", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "4px" }}>
                                                            <a href="javascript:void(0);" onClick={() => selectRosHint(hint)} style={{ textDecoration: "none", color: "#333" }}>{hint.value}</a>
                                                        </div>
                                                    ))}
                                                </div>
                                            </div>

                                            {/* Editor */}
                                            <Editor
                                                style={{ width: '100%', height: 'auto' }}
                                                value={selectedRosHintDescription || ROS}
                                                onTextChange={(e) => handleTextChange2(e.htmlValue)} />
                                        </div>
                                    </Panel>
                                </div>
                                <div>
                                    <div className='col-10' style={{ marginLeft: '-14px' }}>
                                        <Panel style={{ width: '550px' }}>
                                            <div className="summarydata-card-4">
                                                <h3 style={{ fontSize: '18px', marginTop: '10px', color: 'rgb(91, 91, 219)' }}>
                                                    Present Illness
                                                </h3>
                                                <i
                                                    className="pi pi-cog"
                                                    onClick={() => setIllnessDilog(true)}
                                                    style={{
                                                        fontSize: "20px",
                                                        color: "rgb(91, 91, 219)",
                                                        float: "right",
                                                        marginTop: '-20px'
                                                    }}
                                                />
                                                {/* Hints Container */}
                                                {/* <div className="hints-container" style={{ marginTop: '10px' }}>
                                                <div className="fixed-height-container">
                                                    {filteredHpiHints.slice(0, 1).map((hint, index) => (
                                                        <a href="javascript:void(0);" onClick={() => selectHpiHint(hint)} key={index}>
                                                            {hint.value}
                                                        </a>
                                                    ))}
                                                </div>
                                                {filteredHpiHints.length > 1 && (
                                                    <div className="scrollable-hints">
                                                        {filteredHpiHints.slice(1).map((hint, index) => (
                                                            <a href="javascript:void(0);" onClick={() => selectHpiHint(hint)} key={index}>
                                                                {hint.value}
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div> */}
                                                <div className="hints-container" style={{ marginTop: '10px' }}>
                                                    <div style={{ display: "flex", flexDirection: "column", overflowY: "auto", scrollSnapType: "y mandatory", gap: "5px", padding: "5px", maxHeight: "200px" }}>
                                                        {/* Render the first item */}
                                                        {filteredHpiHints.slice(0, 1).map((hint, index) => (
                                                            <div key={index} style={{ flex: "0 0 auto", scrollSnapAlign: "start", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "4px" }}>
                                                                <a href="javascript:void(0);" onClick={() => selectHpiHint(hint)} style={{ textDecoration: "none", color: "#333" }}>{hint.value}</a>
                                                            </div>
                                                        ))}

                                                        {/* Render remaining items, if any */}
                                                        {filteredHpiHints.length > 1 && filteredHpiHints.slice(1).map((hint, index) => (
                                                            <div key={index} style={{ flex: "0 0 auto", scrollSnapAlign: "start", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "4px" }}>
                                                                <a href="javascript:void(0);" onClick={() => selectHpiHint(hint)} style={{ textDecoration: "none", color: "#333" }}>{hint.value}</a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>

                                                {/* Editor */}
                                                <Editor
                                                    style={{ width: '100%', height: 'auto' }}
                                                    value={selectedHpiHintDescription || Illness}
                                                    // onTextChange={filterHpiHints}
                                                    onTextChange={(e) => handleTextChange3(e.htmlValue)} />
                                                {/* <Button icon="pi pi-refresh" onClick={clearHpiSelection} /> */}
                                            </div>
                                        </Panel>
                                        <Panel style={{ width: '550px' }}>
                                            <div className="summarydata-card-4">
                                                <h3 style={{ fontSize: '18px', marginTop: '10px', color: 'rgb(91, 91, 219)' }}>
                                                    Examination
                                                </h3>
                                                <i
                                                    className="pi pi-cog"
                                                    style={{
                                                        fontSize: '20px',
                                                        color: 'rgb(91, 91, 219)',
                                                        float: 'right',
                                                        marginTop: '-20px'
                                                    }}
                                                    onClick={() => setExamDilog(true)}
                                                ></i>
                                                {/* Hints Container */}
                                                {/* <div className="hints-container" style={{ marginTop: '10px' }}>
                                                <div className="fixed-height-container">
                                                    {filteredExamHints.slice(0, 1).map((hint, index) => (
                                                        <a
                                                            href="javascript:void(0);"
                                                            key={index}
                                                            onClick={() => selectExamHint(hint)}
                                                        >
                                                            {hint.value}
                                                        </a>
                                                    ))}
                                                </div>
                                                {filteredExamHints.length > 1 && (
                                                    <div className="scrollable-hints">
                                                        {filteredExamHints.slice(1).map((hint, index) => (
                                                            <a
                                                                href="javascript:void(0);"
                                                                key={index}
                                                                onClick={() => selectExamHint(hint)}
                                                            >
                                                                {hint.value}
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div> */}
                                                <div className="hints-container" style={{ marginTop: '10px' }}>
                                                    <div style={{ display: "flex", flexDirection: "column", overflowY: "auto", scrollSnapType: "y mandatory", gap: "5px", padding: "5px", maxHeight: "200px" }}>
                                                        {/* Render the first item */}
                                                        {filteredExamHints.slice(0, 1).map((hint, index) => (
                                                            <div key={index} style={{ flex: "0 0 auto", scrollSnapAlign: "start", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "4px" }}>
                                                                <a href="javascript:void(0);" onClick={() => selectExamHint(hint)} style={{ textDecoration: "none", color: "#333" }}>
                                                                    {hint.value}
                                                                </a>
                                                            </div>
                                                        ))}

                                                        {/* Render remaining items, if any */}
                                                        {filteredExamHints.length > 1 && filteredExamHints.slice(1).map((hint, index) => (
                                                            <div key={index} style={{ flex: "0 0 auto", scrollSnapAlign: "start", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "4px" }}>
                                                                <a href="javascript:void(0);" onClick={() => selectExamHint(hint)} style={{ textDecoration: "none", color: "#333" }}>
                                                                    {hint.value}
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>
                                                <Editor
                                                    style={{ width: '100%', height: 'auto' }}
                                                    value={selectedExamHintDescription || Examination}
                                                    onTextChange={(e) => handleTextChange4(e.htmlValue)} />
                                            </div>
                                        </Panel>
                                        <Panel style={{ width: '550px' }}>
                                            <div className="summarydata-card-4">
                                                <h3 style={{ fontSize: '18px', marginTop: '10px', color: 'rgb(91, 91, 219)' }}>Assessment & Plan</h3>
                                                <i
                                                    className="pi pi-cog"
                                                    onClick={() => setAssesmentDilog(true)}
                                                    style={{
                                                        fontSize: '20px',
                                                        color: 'rgb(91, 91, 219)',
                                                        float: 'right',
                                                        marginTop: '-20px'
                                                    }}
                                                ></i>

                                                {/* Hints Container */}
                                                {/* <div className="hints-container" style={{ marginTop: '10px' }}>
                                                <div className="fixed-height-container">
                                                    {filteredAssessmentHints.slice(0, 1).map((hint: any) => (
                                                        <a href="javascript:void(0);" key={hint.id} onClick={() => selectAssessmentHint(hint)}>
                                                            {hint.value}
                                                        </a>
                                                    ))}
                                                </div>
                                                {filteredAssessmentHints.length > 1 && (
                                                    <div className="scrollable-hints">
                                                        {filteredAssessmentHints.slice(1).map((hint: any) => (
                                                            <a href="javascript:void(0);" key={hint.id} onClick={() => selectAssessmentHint(hint)}>
                                                                {hint.value}
                                                            </a>
                                                        ))}
                                                    </div>
                                                )}
                                            </div> */}
                                                <div className="hints-container" style={{ marginTop: '10px' }}>
                                                    <div style={{ display: "flex", flexDirection: "column", overflowY: "auto", scrollSnapType: "y mandatory", gap: "5px", padding: "5px", maxHeight: "200px" }}>
                                                        {/* Render the first item */}
                                                        {filteredAssessmentHints.slice(0, 1).map((hint: any) => (
                                                            <div key={hint.id} style={{ flex: "0 0 auto", scrollSnapAlign: "start", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "4px" }}>
                                                                <a href="javascript:void(0);" onClick={() => selectAssessmentHint(hint)} style={{ textDecoration: "none", color: "#333" }}>
                                                                    {hint.value}
                                                                </a>
                                                            </div>
                                                        ))}

                                                        {/* Render remaining items, if any */}
                                                        {filteredAssessmentHints.length > 1 && filteredAssessmentHints.slice(1).map((hint: any) => (
                                                            <div key={hint.id} style={{ flex: "0 0 auto", scrollSnapAlign: "start", padding: "10px", backgroundColor: "#f0f0f0", borderRadius: "4px" }}>
                                                                <a href="javascript:void(0);" onClick={() => selectAssessmentHint(hint)} style={{ textDecoration: "none", color: "#333" }}>
                                                                    {hint.value}
                                                                </a>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </div>


                                                {/* Editor */}
                                                <Editor
                                                    style={{ width: '100%', height: 'auto' }}
                                                    value={selectedAssessmentHintDescription || Assesment}
                                                    onTextChange={(e) => handleTextChange5(e.htmlValue)} />

                                            </div>
                                        </Panel>
                                    </div>
                                </div>
                                <div className='col-14' style={{ padding: '0px 10px' }}>
                                    <Card className="custom-panel" style={{ position: 'relative', padding: '20px', height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', borderLeft: '5px solid #117a8b' }}>
                                        {/* Title */}
                                        <b style={{ fontSize: '18px', color: 'rgb(91, 91, 219)', fontWeight: 'bolder' }}>Diagnosis</b>
                                        {/* Icon */}
                                        <i
                                            className="pi pi-plus"
                                            style={{ position: 'absolute', top: '10px', right: '20px', fontSize: '16px', color: 'rgb(91, 91, 219)', cursor: 'pointer', fontWeight: 'bolder' }} onClick={() => setDaignosisDilog(true)}></i>
                                        {messegess && (
                                            <p >
                                                {diacode} &nbsp; {Description}&nbsp;
                                                <i
                                                    style={{ float: 'right', cursor: 'pointer', marginRight: '-25px', marginTop: '3px', fontWeight: 'bolder' }}
                                                    className="pi pi-times"
                                                    onClick={() => removeDiagnosis(DXID)}
                                                ></i>
                                            </p>
                                        )}
                                    </Card>
                                    <Card className="custom-panel" style={{ position: 'relative', padding: '20px', height: '90px', display: 'flex', alignItems: 'center', justifyContent: 'center', textAlign: 'center', borderLeft: '5px solid #117a8b', marginTop: '20px' }}>
                                        {/* Title */}
                                        <b style={{ fontSize: '18px', color: 'rgb(91, 91, 219)', fontWeight: 'bolder' }}>Procedure</b>
                                        {/* Icon */}
                                        <i
                                            className="pi pi-plus"
                                            style={{ position: 'absolute', top: '10px', right: '20px', fontSize: '16px', color: 'rgb(91, 91, 219)', cursor: 'pointer', fontWeight: '900' }} onClick={() => setProcedureDilog(true)}></i>
                                        {proceduress && (
                                            <p >
                                                {diacodeProcedure} &nbsp; {DescriptionProcedure}&nbsp;
                                                <i
                                                    style={{ float: 'right', cursor: 'pointer', marginRight: '-25px', marginTop: '3px', fontWeight: 'bolder' }}
                                                    className="pi pi-times"
                                                    onClick={() => removeProcedure(PRID)}
                                                ></i>
                                            </p>
                                        )}
                                    </Card>
                                </div>
                            </div>

                        </div>
                    </div>
                    {/* past history dilog */}
                    <Dialog header="Add Past Medical History" visible={openDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!openDilog) return; setOpenDilog(false); }} draggable={false} resizable={false}>
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onChange={(e) => setPastName(e.target.value)}
                            />
                        </div>

                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Title" className="w-full" onChange={(e) => setPastTitile(e.target.value)} />
                        </div>
                        <Editor
                            style={{ width: '100%', height: '40px' }}
                            value={pastmedicalEditable}
                            // onTextChange={(e) => setPastmedicalEditable}
                            onTextChange={async (e: any) => {
                                const content = e.htmlValue;
                                setPastmedicalEditable(content);
                            }} />
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setOpenDilog(false)} />
                            <Button label="Save" style={{ minWidth: '10rem', backgroundColor: 'rgb(37, 99, 235)' }} onClick={addPastMedicalHistory} />
                        </div>
                    </Dialog>
                    {/* current medication dilog */}
                    <Dialog header="Add Current Medication" visible={medicationDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!medicationDilog) return; setMedicationDilog(false); }} draggable={false} resizable={false}>
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onChange={(e) => setCurrentName(e.target.value)}
                            />
                        </div>

                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Title" className="w-full" onChange={(e) => setCurrentTitle(e.target.value)} />
                        </div>
                        <Editor
                            style={{ width: '100%', height: '40px' }}
                            value={currentEditable}
                            // onTextChange={(e) => setPastmedicalEditable}
                            onTextChange={async (e: any) => {
                                const content = e.htmlValue;
                                setCurrentEditable(content);
                            }} />
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setMedicationDilog(false)} />
                            <Button label="Save" style={{ minWidth: '10rem', backgroundColor: 'rgb(37, 99, 235)' }} onClick={addCurrentMedication} />
                        </div>
                    </Dialog>
                    {/* review of system dilog */}
                    <Dialog header="Add Review Of System" visible={rosDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!rosDilog) return; setrosDilog(false); }} draggable={false} resizable={false}>
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onChange={(e) => setReviewName(e.target.value)}
                            />
                        </div>

                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Title" className="w-full" onChange={(e) => setReviewTitle(e.target.value)} />
                        </div>
                        <Editor
                            style={{ width: '100%', height: '40px' }}
                            value={rosEditable}
                            onTextChange={async (e: any) => {
                                const content = e.htmlValue;
                                setRosEditable(content);
                            }} />
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setrosDilog(false)} />
                            <Button label="Save" style={{ minWidth: '10rem', backgroundColor: 'rgb(37, 99, 235)' }} onClick={addRosData} />
                        </div>
                    </Dialog>
                    {/* present illness dilog */}
                    <Dialog header="Add Present Illness" visible={illnessDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!illnessDilog) return; setIllnessDilog(false); }} draggable={false} resizable={false}>
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onChange={(e) => setIllness(e.target.value)}
                            />
                        </div>

                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Title" className="w-full" onChange={(e) => setIllnessTitle(e.target.value)} />
                        </div>
                        <Editor
                            style={{ width: '100%', height: '40px' }}
                            value={illnesseditable}
                            // onTextChange={(e) => setPastmedicalEditable}
                            onTextChange={async (e: any) => {
                                const content = e.htmlValue;
                                setillnesseditable(content);
                            }} />
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setIllnessDilog(false)} />
                            <Button label="Save" style={{ minWidth: '10rem', backgroundColor: 'rgb(37, 99, 235)' }} onClick={addIllnessData} />
                        </div>
                    </Dialog>
                    {/* Examination history dilog */}
                    <Dialog header="Add Examination" visible={ExamDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!ExamDilog) return; setExamDilog(false); }} draggable={false} resizable={false}>
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onChange={(e) => setExamName(e.target.value)}
                            />
                        </div>

                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Title" className="w-full" onChange={(e) => setExamTitle(e.target.value)} />
                        </div>
                        <Editor
                            style={{ width: '100%', height: '40px' }}
                            value={ExamineEditable}
                            // onTextChange={(e) => setPastmedicalEditable}
                            onTextChange={async (e: any) => {
                                const content = e.htmlValue;
                                setExamEditable(content);
                            }} />
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setExamDilog(false)} />
                            <Button label="Save" style={{ minWidth: '10rem', backgroundColor: 'rgb(37, 99, 235)' }} onClick={addExamineData} />
                        </div>
                    </Dialog>
                    {/* Assesment dilog */}
                    <Dialog header="Add Assesment & Plan" visible={AssesmentDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!AssesmentDilog) return; setAssesmentDilog(false); }} draggable={false} resizable={false}>
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onChange={(e) => setAssesmentName(e.target.value)}
                            />
                        </div>

                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Title" className="w-full" onChange={(e) => setassesmentTitle(e.target.value)} />
                        </div>
                        <Editor
                            style={{ width: '100%', height: '40px' }}
                            value={AssesmbleEditable}
                            // onTextChange={(e) => setPastmedicalEditable}
                            onTextChange={async (e: any) => {
                                const content = e.htmlValue;
                                setAssembleEditable(content);
                            }} />
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setAssesmentDilog(false)} />
                            <Button label="Save" style={{ minWidth: '10rem', backgroundColor: 'rgb(37, 99, 235)' }} onClick={addAssesmentData} />
                        </div>
                    </Dialog>


                    <Dialog header="Add Diagnosis" visible={diagnosisDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!diagnosisDilog) return; setDaignosisDilog(false); }} draggable={false} resizable={false} >
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onKeyDown={handleKeyDown} onChange={(e) => setDaignosisName(e.target.value)} />
                        </div>
                        <>
                            {showTable && (
                                <DataTable
                                    value={diagnosisData}
                                    dataKey="id"
                                    globalFilterFields={['code', 'description']}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    showGridlines
                                    header={
                                        <div className="table-header">
                                        </div>
                                    }
                                >
                                    <Column field="code" header="Code" />
                                    <Column field="description" header="Description" />
                                    <Column
                                        header="Action"
                                        body={(rowData) => (
                                            <i
                                                className="pi pi-plus"
                                                onClick={() => handleIconClick(rowData.dxId)}
                                                style={{ cursor: 'pointer' }}
                                            ></i>
                                        )}
                                    />
                                </DataTable>
                            )}
                        </>
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setDaignosisDilog(false)} />



                        </div>
                    </Dialog>
                    <Dialog header="Add Procedure" visible={procedureDilog} position='top' style={{ width: '50vw' }} onHide={() => { if (!procedureDilog) return; setProcedureDilog(false); }} draggable={false} resizable={false}>
                        <div className="p-inputgroup mb-3">
                            <InputText id="name" type="text" placeholder="Name" className="w-full" onKeyDown={handleKeyDown1} onChange={(e) => setProcedureName(e.target.value)} />
                        </div>
                        <>
                            {showTable1 && (
                                <DataTable
                                    value={procedureData}
                                    dataKey="id"
                                    globalFilterFields={['code', 'description']}
                                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                                    showGridlines
                                    header={
                                        <div className="table-header">
                                        </div>
                                    }
                                >
                                    <Column field="code" header="Code" />
                                    <Column field="description" header="Description" />
                                    <Column
                                        header="Action"
                                        body={(rowData) => (
                                            <i
                                                className="pi pi-plus"
                                                onClick={() => handleIconClick1(rowData.dxId)}
                                                style={{ cursor: 'pointer' }}
                                            ></i>
                                        )}
                                    />
                                </DataTable>
                            )}
                        </>
                        <div className="flex flex-wrap justify-content-center gap-3" style={{ marginTop: '10px' }}>
                            <Button label="Close" severity="secondary" style={{ minWidth: '10rem' }} onClick={() => setProcedureDilog(false)} />
                        </div>
                    </Dialog>


                </div>
            </div>
        </div>

    )
}
